var render, staticRenderFns
import script from "./ElemBase.vue?vue&type=script&lang=js"
export * from "./ElemBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports